export default {
  title: 'Michelin GP',
  navColor: 'transparent',
  navTextColor: 'grey-9',
  showNav: false,
  dialogDealer: false,
  typeVehicle: 'Auto',
  dialogMainMenu: false,
  drawerMenu: false,
  backTo: {}
}
